import { HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { timeout } from 'rxjs';

/**
 * Таймаут запроса в мс. Angular HttpClient по умолчанию НЕ имеет таймаута, и
 * зависший запрос крутится бесконечно (UI отрисован, спиннер навсегда).
 *
 * Значение по умолчанию ограничивает всю операцию (включая 401 → refresh →
 * повтор, т.к. интерсептор стоит первым/внешним). Для заведомо долгих запросов
 * (выгрузки/отчёты) переопределите на больший лимит или `0` (без таймаута):
 *   http.get(url, { context: new HttpContext().set(REQUEST_TIMEOUT_MS, 0) })
 */
export const REQUEST_TIMEOUT_MS = new HttpContextToken<number>(() => 30_000);

/**
 * HttpContext, отключающий глобальный таймаут для заведомо долгих запросов —
 * multipart-выгрузок отчётов/документов/изображений (до десятков МБ), которые
 * на медленном соединении легитимно превышают 30 с. Точечно сохраняет прежнее
 * поведение (HttpClient без таймаута), не ослабляя лимит для остального трафика.
 * При наличии своего контекста передайте его, чтобы не потерять другие токены.
 */
export function withoutRequestTimeout(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(REQUEST_TIMEOUT_MS, 0);
}

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const ms = req.context.get(REQUEST_TIMEOUT_MS);
  if (!ms || ms <= 0) {
    return next(req);
  }
  return next(req).pipe(timeout(ms));
};
